'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = replaceLang;

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function replaceLang(localeLabels, defaultLabel, country, language) {
  localeLabels = localeLabels || [];

  // If not, search for country translation (for example search for CN in case of ZH_CN).
  // todo : it should not be CN but ZH_CN to be correct (need BO correction).
  var label = R.find(R.propEq('locale', country.toUpperCase()))(localeLabels);

  if (!label) {
    // If not found, search for language translation (for example search for FR in case of FR_BE).
    label = R.find(R.propEq('locale', language.toUpperCase()))(localeLabels);
  }

  // If found, return translation, else return default translation (International english version).
  return label ? R.prop('label', label) : defaultLabel;
}


//////////////////
// WEBPACK FOOTER
// ./~/ui-kit/src/shared/replaceLang.js
// module id = 172
// module chunks = 0